const module = { name: 'Fandango/localStore', exports: {} }; const exports = module.exports;



const MAX_AGE = 1000 * 60 * 60


const FD_KEY_PREFIX = '@fdScr2@'


const RegExes = {
    IS_FD_KEY_PREFIX: /^@fdScr2@/,
}


let hasStorage = false
function toKey(type, key) {
    return FD_KEY_PREFIX + type + '___' + key;
}
function doGarbageCollection() {
    const timestamp = Date.now();
    for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (!RegExes.IS_FD_KEY_PREFIX.test(key)) {
            continue;
        }
        let data = localStorage.getItem(key);
        if (!data) {
            continue;
        }
        data = JSON.parse(data);
        if (data && data.expires && (data.expires < timestamp)) {
            localStorage.removeItem(key);
        }
    }
}
function getItem(type, key) {
    if (!hasStorage) {
        return;
    }
    doGarbageCollection();
    let data = localStorage.getItem(toKey(type, key));
    if (!data) {
        return false;
    }
    data = JSON.parse(data);
    return data.data ? data.data : false;
}
function setItem(type, key, data, opts) {
    if (!hasStorage) {
        return;
    }
    doGarbageCollection();
    opts = Object.assign({}, {
        ttl: MAX_AGE
    }, opts);
    localStorage.setItem(toKey(type, key), JSON.stringify({
        expires: Date.now() + opts.ttl,
        data
    }));
}
function extendLegacy(area, publicInterface) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
function init() {
    hasStorage = Boolean(window.localStorage && typeof localStorage.getItem === 'function');
    if (hasStorage) {
        doGarbageCollection();
    }
}
init();
module.exports = {
    get: getItem,
    set: setItem
};
extendLegacy('localStore', module.exports);
export default module.exports;